import React, { useEffect, useState } from "react";
import { Toolbar, Typography, Box } from "@mui/material";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import { ChangeLogType } from "../../../types/genericType";
import ChangeLogTable from "../../../components/changeLogTable/ChangeLogTable";
import { getChangeLogs } from "../../../services/logsService";

const ChangeLog = () => {
  const [search, setSearch] = useState("");
  const [changeLogs, setChangeLogs] = useState<ChangeLogType[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const initialLoad = () => {
    setIsLoading(true);
    getChangeLogs()
      .then((res) => {
        const dataWithIds = res.map((log, index) => ({
          ...log,
          id: `description-${index}`,
        }));
        setIsLoading(false);
        setChangeLogs(dataWithIds);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    initialLoad();
  }, []);

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSearch(event.target.value);
  };

  const clearSearch = () => {
    setSearch("");
  };

  const searchTerm = search.toLowerCase();
  const filteredData = changeLogs.filter((log) =>
    [
      log.description,
      log.modifiedBy,
      log.operation,
      log.activity,
      log.client,
      log.accountNumber,
    ].some((value) => value?.toLowerCase().includes(searchTerm))
  );

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="transactions-history-title">
          Change Log
        </Typography>
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        {isLoading ? (
          <TableRowsLoader rowsNum={10} />
        ) : changeLogs.length > 0 ? (
          <ChangeLogTable
            data={filteredData}
            search={search}
            onSearchChange={handleSearchChange}
            clearSearch={clearSearch}
          />
        ) : (
          <Typography>No Change Log records found</Typography>
        )}
      </Box>
    </>
  );
};

export default ChangeLog;
